import { put } from 'redux-saga/effects';
import { addNotificationAction } from 'store/notifications/notificationsActions';

export const putNotifySuccess = message => put(addNotificationAction({ message, variant: 'success' }));
export const putNotifyError = message => put(addNotificationAction({ message, variant: 'error' }));